// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchDropDown = key => ({
    key,
    type: actions.UPDATE_PRODUCT_SEARCH_BY
});



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/search-dropdown.js